import { Collection } from 'modules/core/lib/mobx-rest'

import ShiftVersionHistory from 'modules/attendance/store/models/ShiftVersionHistory'

export class ShiftVersionHistories extends Collection<ShiftVersionHistory> {
  get cacheKey(): string {
    return 'shiftVersionHistories'
  }

  model() {
    return ShiftVersionHistory
  }
}
